<template>
  <div>
    <el-row class="el-row elrow" v-if="selectRadioType==0">
      <el-col :span="20">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
          <el-breadcrumb-item @click.native="onBreadcrumb(null)" v-if="taskGropuParent.length>0">根目录</el-breadcrumb-item>
          <el-breadcrumb-item @click.native="onBreadcrumb(item.ID)" v-for="item in taskGropuParent" :key="item.ID">{{item.TASKNAME}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="selectFolderType" size="small" class="topCard">
          <el-radio-button label="0">
            <i class="iconfont icon-liebiao"></i>
          </el-radio-button>
          <el-radio-button label="1">
            <i class="iconfont icon-weibiaoti5"></i>
          </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <TaskGroupWorkRecord v-if="selectRadioType==1" @changeCurTask="changeCurTask"></TaskGroupWorkRecord>
    <div v-else>
      <TaskFolderList v-if="selectFolderType==0"></TaskFolderList>
      <TaskGroupList v-if="selectRadioType == 0 && selectFolderType==1" @changeCurTask="changeCurTask"></TaskGroupList>
    </div>
    <div class="el-row">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" :page-sizes="[10, 30, 50, 100]" layout="total, sizes,prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import icon from "@/components/common/icon.vue";
  import TaskGroupList from "@/views/task/components/taskFolder";
  import TaskFolderList from "@/views/task/components/taskFolderList";
  import TaskGroupWorkRecord from "@/views/task/components/TaskGroupWorkRecord";
  import {
    mapState,
    mapActions,
    mapMutations,
    mapGetters
  } from "vuex";
  export default {
    name: "task-group",
    components: {
      icon,
      TaskGroupList,
      TaskGroupWorkRecord,
      TaskFolderList
    },
    data() {
      return {
        listHeight: "200px", // 列表的高度
        curTask: null,
        // totalCount: 0,
        // pageIndex: 1,
        // pageSize: 10,
        selectFolderType: 1
      };
    },
    computed: {
      ...mapState({
        //taskGroupItem: state=> state.task.taskGroupItem,
        selectRadioType: state => state.task.selectRadioType,
        taskGropuParent: state => state.task.taskGropuParent,
        pageSize: state => state.task.taskGroupParas.PageSize,
        totalCount:state => state.task.totalCount,
      }),
      pageIndex: {
        get: function() {
          return this.$store.state.task.taskGroupParas.PageIndex;
        },
        set: function(val) {
          // this.$store.dispatch('changePageIndex', val,this.$store.state.task.type);
        }
      },
    },
    mounted() {
      // this.windowResize();
      // window.onresize = ()=> this.windowResize();
      this.$store.commit("resettaskGroupParas");
      this.$store.dispatch("GetTaskGroupTaskList");
    },
    watch: {
      // 			taskGroupItem(val){
      // 				this.totalCount = (val.TotalItems ? val.TotalItems : 0 );
      // 				this.pageSize = (val.ItemsPerPage ? val.ItemsPerPage : 10 );
      // 				this.pageIndex =  (val.CurrentPage ? val.CurrentPage : 1 );
      // 			}
    },
    methods: {
      onBreadcrumb(id) {
        this.$store.commit("setTaskGroupCurrent", id);
      },
      windowResize() {
        // 树形表格高度自适应。
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          var clientHeight = document.body.clientHeight;
          if (clientHeight < 300) {
            this.listHeight = "200px";
          } else {
            this.listHeight = clientHeight - 162 + "px";
          }
        }, 100);
      },
      changeCurTask(task) {
        this.curTask = task;
        this.$store.commit("changeCurTask", task);
      },
      handleSizeChange(val) {
        this.$store.state.task.taskGroupParas.PageSize = val;
        this.$store.dispatch("GetTaskGroupTaskList");
      },
      handleCurrentChange(val) {
        this.$store.state.task.taskGroupParas.PageIndex = val;
        this.$store.dispatch("GetTaskGroupTaskList");
      }
    }
  };
</script>

<style lang="less" scoped>
  .basePanel {
    height: 100%;
  }
  h3 {
    float: left;
    line-height: 0;
    margin-left: 21px;
    margin-top: 25px;
    color: #424242;
  }
  .topCard {
    float: right; // margin-bottom: 7px;
    // margin-right: 16px;
  }
  .breadcrumb {
    font-size: 16px;
    padding: 8px;
  }
  .elrow {
    background: white;
  }
  .el-row {
    margin-top: 5px;
    background: white;
  }
	.basePanel_div{
		position: static;
	}
</style>
